/* Required so far, as uui-build assumes .index.tsx as an entry. We'll switch to ./src/index.tsx later */
export * from './src';
export * from './i18n';